<script>
  import { LinkedIn, Mastodon } from '$lib/link';
</script>

<svelte:head>
  <title>Contact Us - PGConf.dev 2026</title>
  <meta
    name="description"
    content="Contact the PGConf.dev 2026 team for questions, sponsorship, or to get involved with the conference."
  />
</svelte:head>

<h1>Contact Us</h1>

<p style="text-align: center;">We'd love to hear from you!</p>

<p>
  If you have any questions, comments, or just want to say hi, feel free to
  contact us at <a href="mailto:contact@pgconf.dev">contact@pgconf.dev</a>. You
  can also follow us on <LinkedIn /> or <Mastodon /> for updates about the event.
</p>

<p>
  You can reach the code of conduct committee through email at <a
    href="mailto:coc2026@pgconf.dev">coc2026@pgconf.dev</a
  >
</p>
